import type { QueryEntity } from '@/sections/insights/queryBuilder/entities/types';

import { buildWebApplicationColumns } from './columns';
import { getWebApplicationFields } from './fields';
import { getWebApplicationSimpleFilters } from './simpleFilters';

/**
 * WebApplication QueryEntity - bundles columns and fields
 * WebApplications are Assets with class='webapplication'
 */
export const webApplicationEntity: QueryEntity<unknown> = {
  primaryLabel: { actual: 'WebApplication' },
  buildColumns:
    buildWebApplicationColumns as () => import('@/components/table/types').Columns<unknown>,
  getFields: getWebApplicationFields,
  getSimpleFilters: getWebApplicationSimpleFilters,
};
